import { createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { sanitize } from 'dompurify';
import { disable, enable } from 'body-scroll-manager';
import { RenderInBody } from 'bv-components';
import { t } from 'bv-i18n';

class TutorialComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      offset: 0,
    };

    this.tutorialWrap = createRef();
  }

  componentDidMount() {
    this.updatePositions();
    window.addEventListener('resize', this.updatePositions);
    disable(this.tutorialWrap.current);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updatePositions);
    enable(this.tutorialWrap.current);
  }

  updatePositions = () => {
    const { offsetNode } = this.props;
    const offset = offsetNode.current
      ? window.scrollY + offsetNode.current.getBoundingClientRect().top
      : 0;

    this.setState({ offset });
  };

  render() {
    const { onClose } = this.props;
    const { offset } = this.state;

    return (
      <RenderInBody>
        <div className="inplay-tutorial-overlay" ref={this.tutorialWrap}>
          <div className="inplay-tutorial-header">
            <div className="inplay-tutorial-header-title">{t('javascript.in_play.tutorial.title')}</div>
            <button type="button" onClick={onClose} className="inplay-tutorial-header-close-button" />
          </div>
          <div
            className="inplay-tutorial-market-wrapper"
            style={{ top: `${offset}px`, height: `calc(100vh - ${60 + offset}px)` }}
          >
            <div className="inplay-tutorial-text change-markets-text">{t('javascript.in_play.tutorial.change_market')}</div>
            <div className="inplay-tutorial-sketch change-markets-sketch" />

            <div className="inplay-tutorial-sketch change-markets-box" />
            <div className="inplay-tutorial-sketch change-period-sketch" />
            <div className="inplay-tutorial-text change-period-text">{t('javascript.in_play.tutorial.change_period')}</div>

            <div className="inplay-tutorial-sketch upcoming-sketch" />
            <div
              className="inplay-tutorial-text upcoming-location-text"
              dangerouslySetInnerHTML={{ __html: sanitize(t('javascript.in_play.tutorial.upcoming')) }}
            />
          </div>
        </div>
      </RenderInBody>
    );
  }
}

TutorialComponent.propTypes = {
  onClose: PropTypes.isRequired,
  offsetNode: PropTypes.isRequired,
};

export default TutorialComponent;
